import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ErrorHandler, EventEmitter, Inject, Input, OnDestroy, OnInit, Output, ViewChild, ViewEncapsulation } from '@angular/core'
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog'
import { Router } from '@angular/router'
import { CodeCheckService } from '@lemon/core/service/code-check.service'
import { CurrencyService } from '@lemon/core/service/currency.service'
import { DateService } from '@lemon/core/service/date.service'
import { AsiakasService } from 'app/_angular/service/asiakas/asiakas.service'
import { VeroilmoitusEventsService } from 'app/_angular/service/veroilmoitus-events.service'
import { LadataanService } from 'app/_jaettu-angular/service/ladataan.service'
import { IlmoitinVirhe, VeroilmoitusLomakeTunniste } from 'app/_jaettu-lemonator/model/kirjanpito'
import { AsiakasJaettuService } from 'app/_jaettu-lemonator/service/asiakas-jaettu.service'
import { VeroilmoitusTranslationService } from 'app/_jaettu-lemonator/service/veroilmoitus/veroilmoitus-translation.service'
import { Observable } from 'rxjs'
import { takeUntil } from 'rxjs/operators'
import { KirjanpitoVeroilmoitusBaseSpecializedComponent } from '../components/base-veroilmoitus.component'
import { KirjanpitoVeroilmoitusRowNumberComponent } from '../components/veroilmoitus-row-number.component'
import { AVAA_VEROILMOITUKSEN_KENTTA_BROADCAST_CHANNEL, AvaaVeroilmoitusKenttaMessage, VeroilmoituksenMuokkaustiedot } from '../veroilmoitus.component'

export interface KirjanpitoVeroilmoitusLomakeDialogData {
  veroilmoitusObservable: Observable<VeroilmoituksenMuokkaustiedot>
}
@Component({
  selector: '[app-lomake-62-oy-2026]',
  templateUrl: './lomake-62-oy-2026.component.html',
  styleUrls: ['./lomake-rows.styles.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class Lomake62Oy2026Component extends KirjanpitoVeroilmoitusBaseSpecializedComponent implements OnInit, OnDestroy {
  private _avaaVeroilmoitusKenttaChannel: BroadcastChannel
  lomakeTunniste: VeroilmoitusLomakeTunniste = 'VSY062'

  ilmoitinErrorsObservable: Observable<IlmoitinVirhe[]>

  @Input() lukittu: boolean

  @ViewChild('edit800', { static: false, read: KirjanpitoVeroilmoitusRowNumberComponent }) editComponent800: KirjanpitoVeroilmoitusRowNumberComponent
  @ViewChild('edit801', { static: false, read: KirjanpitoVeroilmoitusRowNumberComponent }) editComponent801: KirjanpitoVeroilmoitusRowNumberComponent
  @ViewChild('edit802', { static: false, read: KirjanpitoVeroilmoitusRowNumberComponent }) editComponent802: KirjanpitoVeroilmoitusRowNumberComponent
  @ViewChild('edit804', { static: false, read: KirjanpitoVeroilmoitusRowNumberComponent }) editComponent804: KirjanpitoVeroilmoitusRowNumberComponent
  @ViewChild('edit806', { static: false, read: KirjanpitoVeroilmoitusRowNumberComponent }) editComponent806: KirjanpitoVeroilmoitusRowNumberComponent
  @ViewChild('edit807', { static: false, read: KirjanpitoVeroilmoitusRowNumberComponent }) editComponent807: KirjanpitoVeroilmoitusRowNumberComponent

  @Output() sulje = new EventEmitter<void>()

  constructor(
    @Inject(MAT_DIALOG_DATA) private _data: KirjanpitoVeroilmoitusLomakeDialogData,
    protected _router: Router,
    protected _asiakasService: AsiakasService,
    protected _currencyService: CurrencyService,
    protected _veroilmoitusTranslationService: VeroilmoitusTranslationService,
    protected _dateService: DateService,
    protected _changeDetector: ChangeDetectorRef,
    protected _asiakasJaettuService: AsiakasJaettuService,
    protected _codeCheckService: CodeCheckService,
    protected _dialog: MatDialog,
    protected _ladataanService: LadataanService,
    protected _errorHandler: ErrorHandler,
    protected _veroilmoitusEventsService: VeroilmoitusEventsService,
  ) {
    super(_currencyService, _veroilmoitusTranslationService, _changeDetector, _asiakasService)
  }

  ngOnInit() {
    this._avaaVeroilmoitusKenttaChannel = new BroadcastChannel(AVAA_VEROILMOITUKSEN_KENTTA_BROADCAST_CHANNEL)
    this._avaaVeroilmoitusKenttaChannel.addEventListener('message', (event: MessageEvent<AvaaVeroilmoitusKenttaMessage>) => {
      this.avaaVeroilmoitusKentta(event)
    })

    this.ilmoitinErrorsObservable = this._veroilmoitusEventsService.ilmoitinErrorsObservable

    this.veroilmoitusObservable = this._data.veroilmoitusObservable
    this.veroilmoitusObservable.pipe(takeUntil(this._ngUnsubscribe)).subscribe(v => {
      this.veroilmoitus = v
      this._changeDetector.detectChanges()
    })
  }

  taytaPoistotEhdotus() {
    this.editComponent800.tallennaAnnettuArvo(this._annaEhdotus(this._veroilmoitusEventsService.annaLomakeTunniste(this.lomakeTunniste, '800')))
    this.editComponent801.tallennaAnnettuArvo(this._annaEhdotus(this._veroilmoitusEventsService.annaLomakeTunniste(this.lomakeTunniste, '801')))
    this.editComponent802.tallennaAnnettuArvo(this._annaEhdotus(this._veroilmoitusEventsService.annaLomakeTunniste(this.lomakeTunniste, '802')))
    this.editComponent804.tallennaAnnettuArvo(this._annaEhdotus(this._veroilmoitusEventsService.annaLomakeTunniste(this.lomakeTunniste, '804')))
    this.editComponent806.tallennaAnnettuArvo(this._annaEhdotus(this._veroilmoitusEventsService.annaLomakeTunniste(this.lomakeTunniste, '806')))
    this.editComponent807.tallennaAnnettuArvo(this._annaEhdotus(this._veroilmoitusEventsService.annaLomakeTunniste(this.lomakeTunniste, '807')))
  }

  ngOnDestroy() {
    this._ngUnsubscribe.next()
    this._ngUnsubscribe.complete()
  }

  suljeDialog() {
    this.sulje.emit()
  }
}
